"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientProgressScreen = void 0;
/* eslint-disable max-lines-per-function */
/** @jsx jsx */
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const utils_1 = require("../../components/table/utils");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const subcomponents_1 = require("./subcomponents");
const PATIENT_PROGRESS_PAGE_SIZE = 200;
const PatientProgressScreen = ({ pending, pendingPrograms, pendingSectionsSimple, adminPrograms, simpleSections, patientProgressList, filters, count, user, resetFilters, listPrograms, listSectionsSimple, listPatientProgress, }) => {
    const [isFilterOpen, setIsFilterOpen] = react_1.useState(false);
    const [selectedProgram, setSelectedProgram] = react_1.useState(null);
    const [selectedSection, setSelectedSection] = react_1.useState(null);
    react_1.useEffect(() => {
        if (user && user.isValid) {
            listPrograms();
            listPatientProgress(filters);
        }
        return () => resetFilters();
    }, [user]);
    react_1.useEffect(() => {
        listSectionsSimple({ program: (selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.value) || undefined });
        setSelectedSection(null);
    }, [selectedProgram]);
    const columnsNames = [
        {
            Header: constants_1.default.patientProgress.name,
            accessor: 'fullName',
            minWidth: 200,
            sortable: true,
            Cell: subcomponents_1.TableCells.LinkCell,
        },
        {
            Header: constants_1.default.patientProgress.emailAddress,
            accessor: 'email',
            minWidth: 250,
            sortable: true,
        },
        {
            Header: constants_1.default.patientProgress.program,
            accessor: 'program',
            minWidth: 90,
            sortable: true,
        },
        {
            Header: constants_1.default.patientProgress.section,
            accessor: 'currentSectionName',
            sortable: true,
        },
        {
            Header: constants_1.default.patientProgress.currentStep,
            accessor: 'currentContentName',
            minWidth: 250,
            sortable: false,
        },
        {
            Header: constants_1.default.patientProgress.dateCompleted,
            accessor: 'lastVideoCompletedAt',
            sortable: false,
            minWidth: 100,
            Cell: ({ cell }) => {
                const { row } = cell;
                const { original } = row;
                const dates = [
                    (original === null || original === void 0 ? void 0 : original.lastQuestionCompletedAt) && new Date(original === null || original === void 0 ? void 0 : original.lastQuestionCompletedAt),
                    (original === null || original === void 0 ? void 0 : original.lastSessionCompletedAt) && new Date(original === null || original === void 0 ? void 0 : original.lastSessionCompletedAt),
                    (original === null || original === void 0 ? void 0 : original.lastVideoCompletedAt) && new Date(original === null || original === void 0 ? void 0 : original.lastVideoCompletedAt),
                ].filter((d) => d !== null).sort((a, b) => a.getTime() - b.getTime());
                if (!lodash_1.isEmpty(dates)) {
                    return core_1.jsx("div", null, moment_1.default(dates[0]).format('MM/DD/YYYY hh:mm a'));
                }
                return core_1.jsx("div", null, "--");
            },
        },
    ];
    const onChangeFilters = (values) => {
        listPatientProgress(Object.assign(Object.assign({}, values), { page: 1, nextPage: false }));
    };
    const onChangeSort = (value) => {
        listPatientProgress(Object.assign(Object.assign({}, filters), { ordering: utils_1.cleanSortValue(value), page: 1 }));
    };
    const onSearchChange = lodash_1.debounce((e) => {
        const { value } = e.target;
        const newFilters = Object.assign({}, filters);
        if (value.length === 0) {
            delete newFilters.search;
        }
        else {
            newFilters.search = value;
        }
        onChangeFilters(newFilters);
    }, 300);
    const onChangePage = () => {
        if (count > PATIENT_PROGRESS_PAGE_SIZE && patientProgressList.length < count) {
            listPatientProgress(Object.assign(Object.assign({}, filters), { page: filters.page + 1 }));
        }
    };
    const columns = react_1.useMemo(() => columnsNames, [patientProgressList]);
    return (core_1.jsx("div", { className: styles_scss_1.default.patientProgress },
        core_1.jsx(components_1.Meta, { title: constants_1.default.patientProgress.helmetTitle, removeViewport: true }),
        core_1.jsx(components_1.Paper, { className: styles_scss_1.default.contentPaper },
            core_1.jsx("h2", null, constants_1.default.patientProgress.pageTitle),
            core_1.jsx("div", { className: styles_scss_1.default.tableHeaderCont },
                core_1.jsx("div", { className: styles_scss_1.default.tableHeaderLeftCont },
                    core_1.jsx(components_1.SearchInput, { className: styles_scss_1.default.searchInput, ariaLabel: constants_1.default.patientProgress.searchByName, placeholder: constants_1.default.patientProgress.searchByName, onChange: onSearchChange, name: "search" }),
                    core_1.jsx(components_1.Button, { className: styles_scss_1.default.filterButton, title: constants_1.default.patientProgress.filters, ariaLabel: constants_1.default.patientProgress.filters, isFilter: true, filterCount: [selectedProgram, selectedSection].filter(f => f !== null).length || null, variant: "tertiary-ghost", onClick: () => setIsFilterOpen((prev) => !prev), imgUrls: { default: constants_1.Images.filter, selected: constants_1.Images.filterActive } })),
                core_1.jsx("div", { className: styles_scss_1.default.tableHeaderRightCont })),
            isFilterOpen && (core_1.jsx("div", { className: styles_scss_1.default.filtersCont },
                core_1.jsx(components_1.Dropdown, { className: styles_scss_1.default.programDropdown, ariaLabel: constants_1.default.patientProgress.selectOneProgram, placeholder: constants_1.default.patientProgress.selectOneProgram, value: selectedProgram, disabled: pendingPrograms, name: "program", onChange: (option) => {
                        setSelectedProgram(option.value === '' ? null : option);
                        onChangeFilters(Object.assign(Object.assign({}, filters), { programId: option.value }));
                    }, options: [...[{ id: '', name: 'All programs' }], ...adminPrograms].map((program) => ({
                        label: program.name,
                        value: parseInt(program.id, 10) || '',
                    })), label: constants_1.default.patientProgress.program }),
                core_1.jsx(components_1.Dropdown, { className: styles_scss_1.default.sectionDropdown, ariaLabel: constants_1.default.patientProgress.selectOneSection, placeholder: constants_1.default.patientProgress.selectOneSection, value: selectedSection, disabled: pendingSectionsSimple, name: "section", onChange: (option) => {
                        setSelectedSection(option.value === '' ? null : option);
                        onChangeFilters(Object.assign(Object.assign({}, filters), { currentSectionId: option.value }));
                    }, options: [...[{ id: '', name: 'All sections' }], ...simpleSections].map((section) => ({
                        label: section.name,
                        value: parseInt(section.id, 10) || '',
                    })), label: constants_1.default.patientProgress.section }))),
            core_1.jsx("div", { className: styles_scss_1.default.patientProgressTable, css: styles_1.default.patientProgressTable(isFilterOpen) },
                core_1.jsx(components_1.Table, { data: patientProgressList, columns: columns, searchable: true, onSortChanged: onChangeSort, onEndReached: onChangePage, loading: pending && !filters.nextPage })))));
};
exports.PatientProgressScreen = PatientProgressScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    adminPrograms: selectors_1.default.program.getAdminPrograms(state),
    filters: selectors_1.default.user.getPatientProgressFilters(state),
    simpleSections: selectors_1.default.program.getSimpleSections(state),
    pendingPrograms: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.listPrograms),
    pendingSectionsSimple: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.listSectionsSimple),
    patientProgressList: selectors_1.default.user.getPatientProgressList(state),
    pending: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.listPatientProgress),
    count: selectors_1.default.user.getPatientProgressCount(state),
});
const mapDispatchToProps = {
    listPatientProgress: (data) => radio_dispatch_1.reduxSet.makeLatestRequest.dispatch(api_payloads_1.listPatientProgressPayload(data)),
    listPrograms: () => redux_1.ActionCreators.program.listProgramsRequest.dispatch(),
    listSectionsSimple: (data) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.listSectionsPayload(data)),
    resetFilters: () => redux_1.ActionCreators.user.resetFilters.dispatch(),
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.PatientProgressScreen));
